import { RicosPluginToolbarNames } from 'ricos-types';
import type { EditorPluginCreator } from 'wix-rich-content-common';

import { DEFAULTS } from './consts';
import { getAddButtons } from './getAddButtons';
import { getToolbarButtons } from './getToolbarButtons';
import { Settings } from './settings/settings';
import { tiptapExtensions } from './tiptap/tiptap';
import type { ImagePluginEditorConfig } from './types';
import { IMAGE_TYPE } from './types';

export const pluginImage: EditorPluginCreator<
  ImagePluginEditorConfig,
  { SettingsModal: typeof Settings }
> = config => {
  const pluginConfig: ImagePluginEditorConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: IMAGE_TYPE,
    tiptapExtensions,
    toolbar: {
      names: [RicosPluginToolbarNames.IMAGE],
      getButtons: (config, services) => getToolbarButtons(config, services),
    },
    getAddButtons: (config, services) => getAddButtons(config, services),
    __exports: {
      SettingsModal: Settings,
    },
  };
};
